import { CloseButton, Combobox, TextInput, useCombobox } from '@mantine/core'

export interface TowerAutocompleteOption {
  value: string
  label: string
}

interface TowerAutocompleteProps {
  label: string
  placeholder?: string
  value: string
  onChange: (value: string) => void
  options: TowerAutocompleteOption[]
  disabled?: boolean
  required?: boolean
  description?: React.ReactNode
  error?: string | boolean
}

export function TowerAutocomplete({
  label,
  placeholder,
  value,
  onChange,
  options,
  disabled = false,
  required = false,
  description,
  error,
}: TowerAutocompleteProps) {
  const combobox = useCombobox()
  const shouldFilterOptions = !options.some((item) => item.value === value)
  const filteredOptions = shouldFilterOptions
    ? options.filter(
        (item) =>
          item.value.toLowerCase().includes(value.toLowerCase().trim()) ||
          item.label.toLowerCase().includes(value.toLowerCase().trim()),
      )
    : options
  const comboboxOptions = filteredOptions.map((item) => (
    <Combobox.Option value={item.value} key={item.value}>
      {item.label}
    </Combobox.Option>
  ))

  return (
    <Combobox
      onOptionSubmit={(optionValue) => {
        onChange(optionValue)
        combobox.closeDropdown()
      }}
      store={combobox}
      withinPortal={false}
    >
      <Combobox.Target>
        <TextInput
          label={label}
          placeholder={placeholder || `Enter ${label.toLowerCase()}`}
          value={value}
          onChange={(event) => {
            onChange(event.currentTarget.value)
            combobox.openDropdown()
            combobox.updateSelectedOptionIndex()
          }}
          onClick={() => {
            combobox.openDropdown()
          }}
          onFocus={() => {
            combobox.openDropdown()
          }}
          onBlur={() => {
            combobox.closeDropdown()
          }}
          rightSection={
            value !== '' && (
              <CloseButton
                size="sm"
                onMouseDown={(event) => {
                  event.preventDefault()
                }}
                onClick={() => {
                  onChange('')
                }}
                aria-label="Clear value"
              />
            )
          }
          disabled={disabled}
          required={required}
          description={description}
          error={error}
        />
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options>
          {comboboxOptions.length === 0 ? (
            <Combobox.Empty>Nothing found</Combobox.Empty>
          ) : (
            comboboxOptions
          )}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  )
}
